"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationFormatter = void 0;
const ConfigurationFormValidator_1 = require("./ConfigurationFormValidator");
class ConfigurationFormatter {
    static maxGeschwindigkeit(options) {
        return ConfigurationFormValidator_1.ConfigurationFormValidator.maxGeschwindigkeit(options);
    }
    static beschleunigungMax(options) {
        return ConfigurationFormValidator_1.ConfigurationFormValidator.beschleunigungMax(options);
    }
    static doppelhuebe(options) {
        return ConfigurationFormValidator_1.ConfigurationFormValidator.doppelhuebe(options);
    }
    static minTemperatur(options) {
        return ConfigurationFormValidator_1.ConfigurationFormValidator.minTemperaturValidator(options);
    }
    static maxTemperatur(options) {
        return ConfigurationFormValidator_1.ConfigurationFormValidator.maxTemperaturValidator(options);
    }
    static durchschnittTemperatur(options) {
        return ConfigurationFormValidator_1.ConfigurationFormValidator.durchschnittTemperaturValidator(options);
    }
    static bauraumbreite(options) {
        return ConfigurationFormValidator_1.ConfigurationFormValidator.bauraumbreite(options);
    }
    static bauraumhoehe(options) {
        return ConfigurationFormValidator_1.ConfigurationFormValidator.bauraumhoehe(options);
    }
    static bauraumlaenge(options) {
        return ConfigurationFormValidator_1.ConfigurationFormValidator.bauraumlaenge(options);
    }
    static maxAussenhoehe(options) {
        return ConfigurationFormValidator_1.ConfigurationFormValidator.maxAussenhoehe(options);
    }
    static minInnenhoehe(options) {
        return ConfigurationFormValidator_1.ConfigurationFormValidator.minInnenhoehe(options);
    }
    static minInnenbreite(options) {
        return ConfigurationFormValidator_1.ConfigurationFormValidator.minInnenbreite(options);
    }
    static minKettenBiegeradius(options) {
        return ConfigurationFormValidator_1.ConfigurationFormValidator.minKettenBiegeradius(options);
    }
}
exports.ConfigurationFormatter = ConfigurationFormatter;
//# sourceMappingURL=ConfigurationFormatter.js.map